import { ReactElement } from 'react';

import {
	SelectableRectangleAppend,
	SelectableRectangleContainer,
	SelectableRectangleLabel,
} from './style';

export type Type = 'primary' | 'secondary';

export interface Item {
	key: string;
	append?: ReactElement;
	label: string;
	subItems?: Item[];
}

export interface ItemProps {
	type?: Type;
	selected?: boolean;
	disabled?: boolean;
}

export interface SelectableRectangleProps {
	item: Item;
	type: Type;
	selected?: boolean;
	disabled?: boolean;
	onClick: () => void;
}

export function SelectableRectangle({
	item,
	selected = false,
	disabled = false,
	type = 'primary',
	onClick,
}: SelectableRectangleProps) {
	return (
		<SelectableRectangleContainer type={type} disabled={disabled} selected={selected} onClick={onClick}>
			{item.append && <SelectableRectangleAppend>{item.append}</SelectableRectangleAppend>}
			<SelectableRectangleLabel selected={selected}>{item.label}</SelectableRectangleLabel>
		</SelectableRectangleContainer>
	);
}
